import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./index.css";
import App from "./App";
import BookingPage from "./BookingPage";
import ThankYouPage from "./ThankYouPage";
import ConfirmPage from "./ConfirmPage";
import CancelPage from "./CancelPage";
import { LangProvider } from "./LangContext";
import VerifyEmailPage from "./VerifyEmailPage";
import PasswordResetPage from "./PasswordResetPage";
import PasswordChangeConfirmPage from "./PasswordChangeConfirmPage";
import EmailChangeConfirmPage from "./EmailChangeConfirmPage";
import GoogleOAuthCallbackPage from "./GoogleOAuthCallbackPage";
import ImprintPage from "./ImprintPage";
import PrivacyPage from "./PrivacyPage";
import TermsPage from "./TermsPage";
import Footer from "./components/Footer";
import Banner from "./components/Banner";
import PublicControls from "./components/PublicControls";
import useTheme from "./useTheme";
import { getLang } from "./i18n";

// Set lang on <html> before first paint so <input type="date"> renders in the
// correct locale immediately (useEffect fires too late for the initial render).
document.documentElement.lang = getLang();

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Root() {
  useTheme();
  return (
    <LangProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/book/:publicId" element={<BookingPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/confirm/:token" element={<ConfirmPage />} />
          <Route path="/cancel/:token" element={<CancelPage />} />
          <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
          <Route path="/password-reset/:token" element={<PasswordResetPage />} />
          <Route path="/password-change/:token" element={<PasswordChangeConfirmPage />} />
          <Route path="/email-change/:token" element={<EmailChangeConfirmPage />} />
          <Route path="/google/callback" element={<GoogleOAuthCallbackPage />} />
          <Route path="/imprint" element={<ImprintPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
        <PublicControls />
        <Footer />
        <Banner />
      </Router>
    </LangProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<Root />);
